import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getCompletedReservesReportLoading: false,
  getCompletedReservesReportFailed: false,
  getCompletedReservesReportError: false,
  getCompletedReservesReportMessage: null,
  completedReservesReport: [],

  completedReserveReport: {
    totalRecords: 0,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_COMPLETED_RESERVE_REPORT_LOADING: {
      return {
        ...state,
        getCompletedReservesReportLoading: true,
        getCompletedReservesReportFailed: false,
        getCompletedReservesReportError: false,
        getCompletedReservesReportMessage: null,
        completedReservesReport: [],
      };
    }
    case actionTypes.GET_COMPLETED_RESERVE_REPORT_SUCCESS: {
      return {
        ...state,
        getCompletedReservesReportLoading: false,
        getCompletedReservesReportFailed: false,
        getCompletedReservesReportError: false,
        getCompletedReservesReportMessage: null,
        completedReserveReport: {
          ...action.payload,
        },
        completedReservesReport: [...action.payload.reserves],
      };
    }
    case actionTypes.GET_COMPLETED_RESERVE_REPORT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCompletedReservesReportLoading: false,
        getCompletedReservesReportFailed: true,
        getCompletedReservesReportError: false,
        getCompletedReservesReportMessage: message,
      };
    }
    case actionTypes.GET_COMPLETED_RESERVE_REPORT_REJECT: {
      return {
        ...state,
        getCompletedReservesReportLoading: false,
        getCompletedReservesReportFailed: false,
        getCompletedReservesReportError: true,
        getCompletedReservesReportMessage: null,
      };
    }

    default:
      return state;
  }
};
